import { useQuery } from "@tanstack/react-query";
import adminApiClient from "api/admin";

export const ONBOARDING_IMAGES_QUERY_KEY = "studio-onboarding-images";

const useOnboardingImages = () => {
  return useQuery({
    queryKey: [ONBOARDING_IMAGES_QUERY_KEY],
    queryFn: () => adminApiClient.getOnboardingImages(),
  });
};

export default useOnboardingImages;
